<template>
	<teleport to="body">
		<div v-if="url" ref="root" class="chat-viewer" role="dialog" @click="$emit('close')">
			<img :src="url" alt="" class="chat-viewer__image" />
			<button type="button" class="chat-viewer__close" :aria-label="$t('chat.close')">
				<chat-icon name="close" :size="24" />
			</button>
		</div>
	</teleport>
</template>

<script>
	import ChatIcon from './ChatIcon.vue';

	export default {
		name: 'ChatImageViewer',
		components: { ChatIcon },
		props: {
			url: { type: String, default: null },
		},
		emits: ['close'],
		mounted() {
			window.addEventListener('keydown', this.onKeydown, true);
		},
		beforeUnmount() {
			window.removeEventListener('keydown', this.onKeydown, true);
		},
		methods: {
			// Escape closes the photo before anything under it reacts.
			onKeydown(event) {
				if (event.key === 'Escape' && this.url) {
					event.preventDefault();
					event.stopPropagation();
					this.$emit('close');
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.chat-viewer {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 10004;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 32px;
		background: rgba(0, 0, 0, 0.8);
		cursor: zoom-out;
	}

	.chat-viewer__image {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
		border-radius: 6px;
	}

	.chat-viewer__close {
		position: absolute;
		top: 16px;
		right: 16px;
		display: flex;
		padding: 6px;
		color: var(--white);
		background: rgba(0, 0, 0, 0.4);
		border: 0;
		border-radius: 9999px;
		cursor: pointer;
	}
</style>
